declare var showImageViewerPopup: any;
const maxImgSize = 5242880; //5MB expressed in bytes

import { ChangeDetectorRef, Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import '../../../../../../../../ClearView WebPortal/Scripts/Admin/ImageViewer.js';

@Component({
  selector: 'cv-point-store-product-upload',
  templateUrl: './point-store-product-upload.component.html',
  styleUrls: ['./point-store-product-upload.component.scss']
})
export class PointStoreProductUploadComponent implements OnInit {

  pspes = null;
  uploadedImage = '';
  croppedImage = '';
  inputSelected = false;
  showImagesModal = false;
  confirmImages = false;
  modifiedIndex = null;
  isVariation = false;
  isTemp = false;
  tempImageString = [];
  originalImagesModified = false;
  product = null;
  readOnly = null;

  @ViewChild('pointStoreUploadInput') pointStoreUploadInput: ElementRef<HTMLInputElement>;
  @ViewChild('pointStoreUploadInputSingle') pointStoreUploadInputSingle: ElementRef<HTMLInputElement>;

  @Input() next: (args: number) => void;
  @Input() cancel: () => void;

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private ref: ChangeDetectorRef
  ) {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;//
  }

  ngOnInit(): void {
    /* angular.element(document.querySelector('.pointStoreUploadInput')).on('change', this.handleFileSelect); */
    //angular.element(document.querySelector('.pointStoreUploadInput')).on('click', function (e:any) { this.value = null });
    /* angular.element(document.querySelector('.pointStoreUploadInputSingle')).on('change', this.handleSingleFileSelect); */

    // $(document).on("imageClicked", (e: any) => {
    //   if (this.readOnly == undefined || this.readOnly == false) {
    //     $scope.$evalAsync(() => {
    //       this.pspes.modifiedPointStoreProduct.ImageID = parseInt(e.iID);
    //       let $selImg = $(".actImg.selImg");

    //       $selImg
    //         .removeClass("unchosenImage")
    //         .addClass("chosenImage")
    //         .attr("src", e.img.attr("src"))
    //         .attr("imgID", e.iID);
    //     });
    //   }
    // });
  }

  clearImage() {
    this.pspes.modifiedPointStoreProduct.ImageID = 0;
  }

  openImageViewerPopup() {
    if (this.readOnly == undefined || this.readOnly == false) {
      $(this).addClass("selImg");
      new showImageViewerPopup();
    }
  };

  showImagesModalAction() {
    if (this.pspes.modifiedPointStoreProduct.imageString == undefined)
      this.pspes.modifiedPointStoreProduct.imageString = [];
    this.tempImageString = this.pspes.modifiedPointStoreProduct.imageString.slice(0);
    this.showImagesModal = true;
  }

  triggerUploadClick($event) {
    /* let $clicked = $($event.target);
    $clicked.parents(".images-controller-container").find(".pointStoreUploadInput").trigger("click"); */
    this.pointStoreUploadInput.nativeElement.click();
  }

  triggerUploadSingleClick($event, index, isVariation, isTemp = null) {
    this.modifiedIndex = index;
    this.isVariation = isVariation;
    this.isTemp = isTemp;
    let $clicked = $($event.target);
    $clicked.parents(".images-controller-container").find(".pointStoreUploadInputSingle").trigger("click");
  }

  shouldShowUploadedImage() {
    if (this.product != this.pspes.modifiedPointStoreProduct)
      this.originalImagesModified = false;

    this.product = this.pspes.modifiedPointStoreProduct;
    if (this.product == null) return false;

    if (this.product.MultipleImagesData != null && this.product.MultipleImagesData.length > 0 && this.product.imageString != null && this.product.imageString.length == 0 && !this.originalImagesModified) {
      for (let i = 0; i < this.product.MultipleImagesData.length; i++) {
        if (this.product.MultipleImagesData[i].PointStoreProductVariationID != null) {
          if (this.pspes.modifiedPointStoreProduct.VariationsData != null) {
            let variationIndex = this.pspes.modifiedPointStoreProduct.VariationsData.findIndex((v) => { return v.PointStoreProductVariationID == this.product.MultipleImagesData[i].PointStoreProductVariationID; });
            if (variationIndex > -1)
              this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationImageData = '../Admin/ImageResizer.aspx?imgid=' + this.product.MultipleImagesData[i].PointStoreProductImageID + '&w=auto&h=220';
          }
        } else {
          this.pspes.modifiedPointStoreProduct.imageString.push({ name: "", source: '../Admin/ImageResizer.aspx?imgid=' + this.product.MultipleImagesData[i].PointStoreProductImageID + '&w=auto&h=220' })
        }
      }
    } else if (this.product.ProductImageID != 0 && (this.product.imageString != null && this.product.imageString.length == 0 || this.product.imageString == null) && !this.originalImagesModified) {
      this.pspes.modifiedPointStoreProduct.imageString = [];
      this.pspes.modifiedPointStoreProduct.imageString.push({ name: "", source: '../Admin/ImageResizer.aspx?imgid=' + this.pspes.modifiedPointStoreProduct.ProductImageID + '&w=auto&h=220' })
    }
    return (this.product.imageString != null && this.product.imageString.length > 0) || (this.product.ProductImageID != null && this.product.ProductImageID > 0);
  }

  inputClick() {
    this.inputSelected = true;
  }

  removeImage(index, isTemp) {
    if (isTemp) {
      this.tempImageString.splice(index, 1);
    } else {
      this.pspes.modifiedPointStoreProduct.imageString.splice(index, 1);
      this.originalImagesModified = true;
      if (!this.pspes.modifiedPointStoreProduct.imageString.length)
        this.pspes.modifiedPointStoreProduct.ProductImageID = 0;
    }
  }

  removeVariationImage(index) {
    this.pspes.modifiedPointStoreProduct.VariationsData[index].VariationImageData = null;
    this.originalImagesModified = true;
  }

  confirmUpload() {
    this.showImagesModal = false;
    this.confirmImages = true;
    this.pspes.modifiedPointStoreProduct.imageString = this.tempImageString.slice(0);
    this.originalImagesModified = true;
  }
  cancelUpload() {
    this.showImagesModal = false;
    this.confirmImages = false;
    if (this.pspes.modifiedPointStoreProduct.imageString.length > 0)
      this.tempImageString = this.pspes.modifiedPointStoreProduct.imageString.slice(0);
  }

  handleFileSelect(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const files: FileList = element.files;
    let imagesToUpload = files.length + this.tempImageString.length > 5 ? (5 - this.tempImageString.length) : files.length;

    //For multiple files
    for (let i = 0; i < imagesToUpload; i++) { 
      //If the image is not JPG/JPEG/PNG, or it has a size bigger than the max size allowed, is ignored
      if ((files[i].type != "image/png" && files[i].type != "image/jpeg") || (files[i].size > maxImgSize))
        continue;
      ((file) => {
        let name = file.name;
        let reader = new FileReader();
        reader.onload = (evt) => {
          // get file content  
          this.tempImageString.push({ name: name, source: evt.target.result });
        }
        reader.readAsDataURL(file);
      })(files[i]);
    }
    this.resetUploadInput();
  }

  handleSingleFileSelect(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const file = element.files[0];

    //If the image is not JPG/JPEG/PNG, or it has a size bigger than the max size allowed, is ignored
    if ((file.type != "image/png" && file.type != "image/jpeg") || (file.size > maxImgSize))
      return;      

    let reader = new FileReader();
    reader.onload = (evt) => {
      setTimeout(() => {
        if (this.isTemp) {
          this.tempImageString[this.modifiedIndex].source = evt.target.result;
          this.tempImageString[this.modifiedIndex].name = file.name;
        } else {
          if (this.isVariation) {
            this.pspes.modifiedPointStoreProduct.VariationsData[this.modifiedIndex].VariationImageData = evt.target.result;
          } else {
            if (this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex] == undefined) {
              this.pspes.modifiedPointStoreProduct.imageString.push({ name: file.name, source: evt.target.result });
            } else {
              this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].source = evt.target.result;
              this.pspes.modifiedPointStoreProduct.imageString[this.modifiedIndex].name = file.name;
            }
          }
        }
      }, 0);
    };
    reader.readAsDataURL(file);
    this.resetUploadInputSingle();
  };

  resetUploadInput() {
    this.pointStoreUploadInput.nativeElement.value = '';
  }

  resetUploadInputSingle() {
    this.pointStoreUploadInputSingle.nativeElement.value = '';
  }
}
